import { manageTabs } from "../home";
import { fillDiscovery, fillDiscoveryCases, getEvents } from "../../frameworks/mz-wp-api";
import { tns } from "tiny-slider";
import { discoverySliderOptions, casesSliderOptions } from "../discovery/gallery-view";

const container = document.currentScript.previousElementSibling;
manageTabs(container.querySelector(".tabs"));

function getContainer(sectionClass) {
    return container.querySelector(`.container > .rows .${sectionClass} > .items`);
}

const sections = {
    talks: {
        container: "talks",
        slider: null,
        reqBody: {
            action: "getNews",
        },
        init: function () {
            let container = getContainer(this.container);
            if (container) {
                container.classList.add("loading");
                this.slider = new tns(discoverySliderOptions(container));

                getEvents(this.reqBody).then((res) => {
                    if (this.slider && typeof this.slider.destroy === "function") {
                        this.slider.destroy();
                        this.slider = null;
                        container = getContainer(this.container);
                    }

                    res.posts = res.posts.slice(0, 10);

                    fillDiscovery(res, container);
                    this.slider = new tns(discoverySliderOptions(container));
                });
            }
        },
    },
    cases: {
        container: "cases",
        slider: null,
        reqBody: {
            action: "getCases",
        },
        init: function (tagsList) {
            if (Array.isArray(tagsList)) this.reqBody["tag"] = tagsList.join(",");
            else if (this.reqBody["tag"]) delete this.reqBody["tag"];

            let container = getContainer(this.container);
            if (container) {
                container.classList.add("loading");
                this.slider = new tns(casesSliderOptions(container));

                getEvents(this.reqBody).then((res) => {
                    if (this.slider && typeof this.slider.destroy === "function") {
                        this.slider.destroy();
                        this.slider = null;
                        container = getContainer(this.container);
                    }

                    fillDiscoveryCases(res, container);

                    let casesSliderSettings = casesSliderOptions(container);
                    this.slider = new tns(casesSliderSettings);
                });
            }
        },
    },
    articles: {
        container: "articles",
        slider: null,
        reqBody: {
            action: "getEstudos",
            postType: "artigo",
        },
        init: function (tagsList) {
            if (Array.isArray(tagsList)) this.reqBody["tag"] = tagsList.join(",");
            else if (this.reqBody["tag"]) delete this.reqBody["tag"];

            let container = getContainer(this.container);
            if (container) {
                container.classList.add("loading");
                this.slider = new tns(discoverySliderOptions(container));

                getEvents(this.reqBody).then((res) => {
                    if (this.slider && typeof this.slider.destroy === "function") {
                        this.slider.destroy();
                        this.slider = null;
                        container = getContainer(this.container);
                    }

                    res.posts = res.posts.slice(0, 10);
                    fillDiscovery(res, container);
                    this.slider = new tns(discoverySliderOptions(container));
                });
            }
        },
    },
    sectors: {
        container: "sectors",
        slider: null,
        reqBody: {
            action: "getEstudos",
            postType: "setor",
        },
        init: function (tagsList) {
            if (Array.isArray(tagsList)) this.reqBody["tag"] = tagsList.join(",");
            else if (this.reqBody["tag"]) delete this.reqBody["tag"];

            let container = getContainer(this.container);
            if (container) {
                container.classList.add("loading");
                this.slider = new tns(discoverySliderOptions(container));

                getEvents(this.reqBody).then((res) => {
                    if (this.slider && typeof this.slider.destroy === "function") {
                        this.slider.destroy();
                        this.slider = null;
                        container = getContainer(this.container);
                    }

                    res.posts = res.posts.slice(0, 10);
                    fillDiscovery(res, container);
                    this.slider = new tns(discoverySliderOptions(container));
                });
            }
        },
    },
    studies: {
        container: "studies",
        slider: null,
        reqBody: {
            action: "getEstudos",
            postType: "estudo",
        },
        init: function (tagsList) {
            if (Array.isArray(tagsList)) this.reqBody["tag"] = tagsList.join(",");
            else if (this.reqBody["tag"]) delete this.reqBody["tag"];

            let container = getContainer(this.container);
            if (container) {
                container.classList.add("loading");
                this.slider = new tns(discoverySliderOptions(container));

                getEvents(this.reqBody).then((res) => {
                    if (this.slider && typeof this.slider.destroy === "function") {
                        this.slider.destroy();
                        this.slider = null;
                        container = getContainer(this.container);
                    }

                    res.posts = res.posts.slice(0, 10);
                    fillDiscovery(res, container);
                    this.slider = new tns(discoverySliderOptions(container));
                });
            }
        },
    },
    boardTalks: {
        container: "boardTalks",
        slider: null,
        reqBody: {
            action: "getBoardTalks",
        },
        init: function (tagsList) {
            if (Array.isArray(tagsList)) this.reqBody["tag"] = tagsList.join(",");
            else if (this.reqBody["tag"]) delete this.reqBody["tag"];

            let container = getContainer(this.container);
            if (container) {
                container.classList.add("loading");
                this.slider = new tns(discoverySliderOptions(container));

                getEvents(this.reqBody).then((res) => {
                    if (this.slider && typeof this.slider.destroy === "function") {
                        this.slider.destroy();
                        this.slider = null;
                        container = getContainer(this.container);
                    }

                    res.posts = res.posts.slice(0, 10);
                    fillDiscovery(res, container);
                    this.slider = new tns(discoverySliderOptions(container));
                });
            }
        },
    },
};

function renderDiscoveryEvents(tagsList) {
    sections.talks.init(tagsList);
    sections.cases.init(tagsList);
    sections.articles.init(tagsList);
    sections.sectors.init(tagsList);
    sections.studies.init(tagsList);
    sections.boardTalks.init(tagsList);
}

renderDiscoveryEvents();
